import React from "react";
import { observer } from "mobx-react";

import LmtLsEventStore from "@state/stores/side-widgets/LmtLsEventStore";
import { EventOffer } from "@gp/offer";
import { EventContext, SportOfferContext } from "@gp/components";

import { TeamName } from "@features/offer/desktop/common";
import WidgetToggleButton from "@features/offer/desktop/buttons/WidgetToggleButton";
import LiveStreamToggleButton from "@features/offer/desktop/buttons/LiveStreamToggleButton";
import OfferIcon from "@components/icons/Offer";

type TEventListTabs = "LMT" | "LS";

export const EventRow = observer(
	(props: {
		lmtLsStore: LmtLsEventStore;
		event: EventOffer;
		tab: TEventListTabs;
	}) => {
		const sport = props.lmtLsStore.lookupsStore.sports.get(
			props.event.sportId
		);

		const teamA = props.lmtLsStore.lookupsStore.teams.get(
			props.event.teamOneId || ""
		);
		const teamB = props.lmtLsStore.lookupsStore.teams.get(
			props.event.teamTwoId || ""
		);

		if (teamA == null || teamB == null) {
			return null;
		}

		return (
			//@ts-expect-error
			<SportOfferContext.Provider value={sport}>
				<EventContext.Provider value={props.event}>
					<div className="widget__list__item">
						<div className="u-display--f u-gap--tny">
							<OfferIcon
								type="sport"
								sport={sport?.abrv || ""}
								className="event__icon event__icon--sport u-icon u-icon--med u-icon--sport"
							/>
							<div className="widget__list__match">
								<TeamName team={teamA} />
								<p>-</p>
								<TeamName team={teamB} />
							</div>
						</div>
						{props.tab === "LMT" && (
							<WidgetToggleButton isForSideWidget />
						)}
						{props.tab === "LS" && (
							<LiveStreamToggleButton
								isForSideWidget
								isOnlyOpen
								isOfferButton
							/>
						)}
					</div>
				</EventContext.Provider>
			</SportOfferContext.Provider>
		);
	}
);
